import { useFormikContext } from 'formik';
import { ICONS } from 'Components/utils/icon/icons';
import { Button } from 'Components/frameworks/button/Button';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import React from 'react';
import { t } from 'Src/i18n';
import type { FormValues } from './PrebookingForm.utils';
import { ModifyButton } from './ModifyButton';
export const ActionsEstimationCostProposal = ({
  hasPrice,
  formStep,
  setFormStep,
  resetProposal,
}: {
  hasPrice: boolean;
  formStep: number;
  setFormStep: (formStep: number) => void;
  resetProposal: () => void;
}) => {
  const { isSubmitting } = useFormikContext<FormValues>();
  const { trackClickEvent } = useTrackEvent();
  return (
    <div className="flex flex-col justify-center space-y-15 md:flex-row md:space-y-0">
      <ModifyButton
        hasPrice={hasPrice}
        formStep={formStep}
        setFormStep={setFormStep}
        resetProposal={resetProposal}
      />
      {formStep === 2 ? (
        <Button
          key="prebooking-submit"
          id="prebooking-submit"
          iconRight={{
            name: ICONS.ARROW_RIGHT,
          }}
          className="bg-primary mx-10"
          data-testid="prebooking-submit"
          isLoading={isSubmitting}
          type="submit"
        >
          {t('prebookingForm.sendRequest')}
        </Button>
      ) : (
        <Button
          key="prebooking-continue"
          id="prebooking-continue"
          className="bg-primary mx-10"
          onClick={() => {
            const detailClick = hasPrice ? 'continue_with_price' : 'continue_without_price';
            trackClickEvent(TRACK_EVENT_NAMES.CLICK_PREBOOKING_FORM_PREREG, {
              detail_click: detailClick,
            });
            setFormStep(2);
          }}
        >
          {t('prebookingForm.continueRequest')}
        </Button>
      )}
    </div>
  );
};
